import { render, staticRenderFns } from "./ProductListingsContent.vue?vue&type=template&id=20270cd4&scoped=true&"
import script from "./ProductListingsContent.vue?vue&type=script&lang=js&"
export * from "./ProductListingsContent.vue?vue&type=script&lang=js&"
import style0 from "./ProductListingsContent.vue?vue&type=style&index=0&id=20270cd4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20270cd4",
  null
  
)

export default component.exports